import { ReactNode, useEffect, useMemo } from 'react';

import { ReceptionistsContext, receptionistsContext } from './receptionistsContext';
import { useFetchCustomRules } from '../../hooks/useFetchCustomRules';
import { useStorageState } from '../../hooks/useStorageState';

type Props = {
  children: ReactNode;
};

const ACTIVE_RECEPTIONIST_STORAGE_KEY = 'active_receptionist';

export const ReceptionistsProvider = ({ children }: Props) => {
  const { data, isLoading, isFetched } = useFetchCustomRules();
  const [activeReceptionist, setActiveReceptionist] = useStorageState(ACTIVE_RECEPTIONIST_STORAGE_KEY);

  useEffect(() => {
    if (activeReceptionist === null && data?.invoiceMention.values && data.invoiceMention.values.length > 0) {
      setActiveReceptionist(data.invoiceMention.values[0]);
    }
  }, [activeReceptionist, data?.invoiceMention.values, setActiveReceptionist]);

  const contextValue = useMemo<ReceptionistsContext>(
    () => ({
      isLoading,
      isFetched,
      receptionists: data?.invoiceMention.values ?? [],
      activeReceptionist,
      setActiveReceptionist,
    }),
    [activeReceptionist, data?.invoiceMention, isFetched, isLoading, setActiveReceptionist],
  );

  return <receptionistsContext.Provider value={contextValue}>{children}</receptionistsContext.Provider>;
};
